import service from '@/utils/request';
export var generateGoogleCode = function generateGoogleCode(data) {
  return service({
    url: '/google/generateGoogleCode',
    method: 'post',
    data: data
  });
};
export var bindingGoogleCode = function bindingGoogleCode(data) {
  return service({
    url: '/google/bindingGoogleCode',
    method: 'post',
    data: data
  });
};